module.exports = __webpack_public_path__ + "static/media/NewCompany.469112d5.svg";